import { join } from 'path'
import { Module } from '@nestjs/common'
import { ConfigModule, ConfigService } from '@nestjs/config'
import { SequelizeModule } from '@nestjs/sequelize'
import { ServeStaticModule } from '@nestjs/serve-static'
import { PlataformaServerModule } from '../../../sistema-mensajes/server/plataforma/plataforma.module'
import { WebhookServerModule } from '../../../sistema-mensajes/server/webhook/webhook.module'
import { AppController } from './app.controller'
import { AppService } from './app.service'

@Module({
  imports: [
    ConfigModule.forRoot({
      envFilePath: 'dist/apps/sistema-mensajes-api/.env',
      isGlobal: true,
    }),
    PlataformaServerModule,
    WebhookServerModule,
    SequelizeModule.forRootAsync({
      imports: [ConfigModule],
      useFactory: (configService: ConfigService) => ({
        dialect: 'mysql',
        host: configService.get('HOST'),
        port: parseInt(configService.get('PORTDATABASE')),
        username: configService.get('USERDATABASE'),
        password: configService.get('PASSWORD'),
        database: configService.get('DATABASE'),
        models: [],
        autoLoadModels: true,
        synchronize: true,
        logging: true,
        sync: { alter: configService.get('SYNCDATABASE') },
      }),
      inject: [ConfigService],
    }),
    ServeStaticModule.forRoot({
      rootPath: join(__dirname, '..', 'pos'),
    }),
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
